import { withStyles } from '@material-ui/core';
import React from 'react';

import ChartBar from '@/components/DistributionChart/ChartBar';
import { userStatus } from '@/utils/labels';

export const getBarComponent = ({ status, styles }) => {
  const CustomBar = props => <ChartBar label={userStatus(status)} {...props} />;

  return withStyles(styles)(CustomBar);
};
